<template>
    <div class="particulars-page">
        <!--  城市选择  -->
        <citySelect serviceProvider="2" @chioce="chioceCity"></citySelect>
        <div class="bottom-wrap">
            <!--    搜索   -->
            <div class="search">
                <div class="search-content">
                    <input placeholder="输入用户的姓名、电话或地址" type="text" class="search" v-model="sSearchText"/>
                    <img :src="require('@/assets/images/service/search-middle-icon.png')" class="icon" alt=""
                         @click="searchSubmit"/>
                </div>
                <div class="order">
                    <img @click="showOrderPop" :src="require('@/assets/images/service/customerscoring/down_icon.png')"
                         alt=""/>
                    <!-- 顺序选择框 -->
                    <div class="order-pop" v-show="isOrderSwitch">
                        <div class="order-item" @click="orderSearch(item.id)" v-for="(item, index) in arrOrderType"
                             :key="index">{{ item.name }}
                        </div>
                    </div>
                </div>
            </div>

            <!--    用户列表    -->
            <div class="user-list-wrap">
                <div class="list-scroll-wrap">
                    <van-list
                        v-model:loading="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        :immediate-check="false"
                        @load="onLoadMore"
                    >
                        <userSelfScore v-for="item in arrUserContractList" :userInfo="item" :key="item.id"  class="user-entity"></userSelfScore>
                    </van-list>
                </div>
            </div>

            <!--    主页按钮    -->
        </div>
        <img @click="$router.push('/hvac/customerscoring/index')" class="home-icon"
             :src="require('@/assets/images/service/home-icon.png')"/>

    </div>
</template>

<script>
import userSelfScore from "@/page/service/components/userselfscore";
import {mapState} from "vuex";
import {getProjectDetail} from "@/js/service";
import oStorage from '@/libsV2/storage.js';
import {fetchVerifyAuthForB} from '@/libsV2/havc.js';
import citySelect from "@/page/service/components/cityselect";
import {Toast} from 'vant';

export default {
    name: "particulars",
    data() {
        return {
            finished:false,
            loading:false,
            isMore: true,
            nPage: 0,
            arrTypeProject: ["空调壁挂炉", "空调壁挂炉", "空调壁挂炉"], //项目类型
            isShowTypeSwitch: false, //项目类型选择框
            arrOrderType: [{id: 11, name: '完工时间正序'}, {id: 12, name: '完工时间倒序'}, {id: 5, name: '综合服务升序'}, {
                id: 6,
                name: '综合服务降序'
            }],
            isOrderSwitch: false, //顺序选择框
            platformInfo: {},//平台信息
            sSearchText: '',//搜素关键字
            sCompanyId: '',//服务商id
            nCityId: '',//城市id
            sAreaId: '',//大区id
            nSort: 12,
            bMore: false,
        };
    },
    components: {
        userSelfScore,
        citySelect
    },
    computed: {
        ...mapState({
            // 用户合同列表
            arrUserContractList: (state) => state.serviceParticulars.arrUserContractList,
        }),
    },
    mounted() {


        fetchVerifyAuthForB(() => {
            this.$store.commit("loadSwitch", true);
            this.sCompanyId = this.$store.state.companyId || oStorage.getStorage('companyId');
            this.$store.commit("editProjectDetail", []);
            this.getProjectDec(this.sCompanyId, this.sSearchText, this.nSort, this.sAreaId, this.nCityId)
        })
    },
    methods: {
        onLoadMore() {
            if (this.isMore) {
                this.nPage++
                this.bMore = true
                this.getProjectDec(this.sCompanyId, this.sSearchText, this.nSort, this.sAreaId, this.nCityId)
            }
        },
        chioceCity(e) {
            this.nPage = 0
            this.$store.commit("editProjectDetail",[]);
            // 判断是否是清除
            if(e.sClearType){
                if(e.sClearType=='DQ'){
                    this.sCompanyId=''
                    this.nCityId=''
                    this.sAreaId=''
                }else if(e.sClearType=='BSC'){
                    this.sCompanyId=''
                    if(e.clearCity){
                        this.nCityId=''
                    }
                }else if(e.sClearType=='CS'){
                    this.nCityId=''
                    if(e.clearSrevice){
                        this.sCompanyId=''
                    }
                }
                this.getProjectDec(this.sCompanyId, this.sSearchText, '', this.sAreaId, this.nCityId)
                return
            }
            //   选择城市
            if (e.third_uuid) {
                //  选择服务商
                this.sCompanyId = e.third_uuid
                this.getProjectDec(e.third_uuid, this.sSearchText, '', this.sAreaId, this.nCityId)
            } else if (e.id) {
                // x选择城市
                this.nCityId = e.id
                if(e.isClearCompany){
                    this.sCompanyId=''
                }
                this.getProjectDec(this.sCompanyId, this.sSearchText, '', this.sAreaId, e.id)
            } else {
                // 选择大区
                // this.sAreaId = e.areaName
                this.sAreaId = e
                this.sCompanyId=''
                this.nCityId=''
                // this.getProjectDec(this.sCompanyId, this.sSearchText, '', e.areaName, this.nCityId)
                this.getProjectDec(this.sCompanyId, this.sSearchText, '', e, this.nCityId)
            }

        },
        //   排序
        orderSearch(sort) {
            this.nPage = 0
            this.getProjectDec(this.sCompanyId, this.sSearchText, sort, this.sAreaId, this.nCityId)
            this.isOrderSwitch = false
            this.nSort = sort
        },
        //   搜搜
        searchSubmit() {
            this.nPage = 0
            this.getProjectDec(this.sCompanyId, this.sSearchText, '', this.sAreaId, this.nCityId)
        },
        //   获取项目明细
        getProjectDec(companyId, searchText, sort, areaId, cityId) {
            this.isMore = false
            this.$store.commit("loadSwitch", true);
            getProjectDetail({
                company_id: companyId,
                search_info: searchText,
                sort: sort,
                area_id: areaId,
                city_id: cityId,
                page: this.nPage,
                limit: 10
            }).then((res) => {
                this.$store.commit("loadSwitch", false);
                this.platformInfo = res.data.data.result.platform_info
                if(res.data.data.result.list.length==0){
                    Toast({message: "没有更多了!"})
                    this.finished=true
                    return
                }
                if (this.bMore) {
                    this.$store.commit("editProjectDetail", [...this.arrUserContractList, ...res.data.data.result.list]);
                    this.isMore = true
                } else {
                    this.$store.commit("editProjectDetail", res.data.data.result.list);
                    this.isMore = true
                }
                this.bMore = false
                this.loading=false//关闭vant loading
            });
        },
        // 项目类型框
        showTypeSwitch() {
            this.isShowTypeSwitch = !this.isShowTypeSwitch;
        },
        // 顺序选择框
        showOrderPop() {
            this.isOrderSwitch = !this.isOrderSwitch;
        },
    },
};
</script>

<style scoped lang="scss">
.particulars-page {
    //   min-height: 100vh;
    color: $commonText;
    overflow: auto;
    scroll-behavior: smooth;
    background: $defaultBackgroundGary;

    .bottom-wrap {
        // padding: 0px 24px 4px;
        box-sizing: border-box;
        // transform: translateY(-25px);
        margin-top: 20px;
    }

    .head-content {
        color: #ffffff;
        // margin-bottom: 26px;
        position: relative;
        background: url("../../../assets/images/service/service-background-samll.png") no-repeat center / cover;
        padding: 28px 24px 60px;

        .switch-type {
            width: 220px;
            height: 64px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 12px;
            border: 2px solid rgba(255, 255, 255, 0.29);
            position: absolute;
            right: 0;
            top: 0;

            .content {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                span {
                    font-size: 24px;
                    font-weight: 500;
                    color: #ffffff;
                    padding-right: 10px;
                }

                img {
                    width: 20px;
                    height: auto;
                }
            }

            .type-content {
                width: 232px;
                background: #ffffff;
                box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
                border-radius: 7px;
                position: absolute;
                top: 70px;
                right: 0;
                z-index: 999;

                .type-item {
                    width: 100%;
                    font-size: 24px;
                    font-weight: 400;
                    color: #444444;
                    line-height: 34px;
                    text-align: center;
                    padding: 24px 0;
                }
            }
        }

        .agent-name {
            font-size: $bigSize;
            font-weight: 500;
            line-height: 44px;
            margin-bottom: 12px;
        }

        .sum {
            font-size: $smallSize;
            line-height: 34px;
            color: rgba(#ffffff, 0.8);
            margin-bottom: 12px;

            &:last-of-type {
                margin-bottom: 0;
            }
        }
    }

    .search {
        display: flex;
        justify-content: space-between;

        .search-content {
            width: 582px;
            //   width: 100%;
            padding: 20px 28px;
            border-radius: $commonRadius;
            background: #ffffff;
            font-size: $baseSize;
            line-height: 32px;
            color: #a2a2a2;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 28px;
            box-shadow: $boxShadow;

            .search {
                width: 100%;

                &::placeholder {
                    color: #a2a2a2;
                }
            }

            .icon {
                width: 40px;
                height: 40px;
                margin-left: 28px;
            }
        }

        .order {
            width: 100px;
            height: 80px;
            background: #ffffff;
            box-shadow: 0px 4px 8px 0px rgba(228, 228, 228, 0.5);
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            img {
                width: 40px;
                height: 40px;
            }

            .order-pop {
                position: absolute;
                width: 232px;
                background: #ffffff;
                box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
                border-radius: 7px;
                top: 98px;
                right: 0;
                z-index: 999;
                padding: 0 20px;

                .order-item {
                    padding: 24px 0;
                    text-align: center;
                    font-size: 24px;
                    font-weight: 400;
                    color: #444444;
                    border-bottom: 1px solid #f5f5f5;
                }
            }
        }
    }

    .user-entity {
        margin-bottom: 28px;
        height: 286px;
    }

    .home-icon {
        width: 156px;
        height: 156px;
        position: fixed;
        bottom: 120px;
        right: 20px;
    }

    .user-list-wrap {
        overflow: scroll;
        height: 1000px;
    }
}
</style>
